/**
 * The one TS reader of a grid's row order. Mirrors Python
 * `MatrixRatingResponse.randomizeRows` / `MatrixCategoricalResponse.randomizeRows`:
 * absent means random, and only an explicit `false` fixes the rows. The
 * compiler, the Randomize pill and the editor read it only through here, so
 * "absent" means one thing in every language.
 */
export function gridRowsRandomized(response: { randomizeRows?: boolean }): boolean {
  return response.randomizeRows !== false;
}
